import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AbstractPage } from 'src/app/AbstractPage';
import { ChiaveConfig } from 'src/app/models/configurazioni/ChiaveConfig';
import { ConfigService } from 'src/app/services/config-service/config-service';
import { EventsService } from 'src/app/services/eventsService';
import { RilevazionePresenzeService } from 'src/app/services/rilevazione-presenze-service';
import { UserService } from 'src/app/services/user-service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
    selector: 'app-ril-filter',
    templateUrl: './ril-filter.component.html',
    styleUrls: ['./ril-filter.component.scss'],
    standalone: false
})
export class RilFilterComponent extends AbstractPage implements OnInit {

  @Input() raggruppamento: string;
  @Output() anno = new EventEmitter<string>();

  // gli anni utilizzati dal filtro
  annoSolareCorrente = new Date().getFullYear();
  annoAccademicoCorrente = Number(this.configService.getConfigurazione(ChiaveConfig.ANNO_ACCADEMICO));
  anniSolare: string[] = [this.annoSolareCorrente.toString()];
  anniOfferta: string[] = [this.annoAccademicoCorrente.toString() + '/' + (this.annoAccademicoCorrente + 1).toString()];

  filtroRil: string;
  filtroAtt: string;
  filtroPres: string;
  filtroDelegheAtt: string;
  filtroStorico: string;

  constructor(
    public navCtrl: NavController,
    public router: Router,
    public route: ActivatedRoute,
    public rilevazionePresenzeService: RilevazionePresenzeService,
    public utilityService: UtilityService,
    public configService: ConfigService,
    public events: EventsService,
    public userService: UserService
  ) {
    super(navCtrl, router);
    this.filtroRil = this.annoSolareCorrente.toString();
    this.filtroPres = this.annoSolareCorrente.toString();
    this.filtroAtt = this.annoAccademicoCorrente.toString() + '/' + (this.annoAccademicoCorrente + 1).toString();
    this.filtroDelegheAtt = this.annoAccademicoCorrente.toString() + '/' + (this.annoAccademicoCorrente + 1).toString();
    this.filtroStorico = this.annoAccademicoCorrente.toString() + '/' + (this.annoAccademicoCorrente + 1).toString();
    this.calcolaFiltroAnnoSolare();
    this.calcolaFiltroAnnoAccademico();
  }

  ngOnInit() {
  }

  aggiungiAnno() {
    let annoCorrente;
    switch (this.raggruppamento) {
      case 'rilevazioni':
        annoCorrente = this.filtroRil;
        this.anno.emit(annoCorrente);
        return;
      case 'presenze':
        annoCorrente = this.filtroPres;
        this.anno.emit(annoCorrente);
        return;
      case 'attivitaReali':
        annoCorrente = this.filtroAtt;
        this.anno.emit(annoCorrente);
        return;
      case 'attivitaRealiModuliInteg':
        annoCorrente = this.filtroAtt;
        this.anno.emit(annoCorrente);
        return;
      case 'attive':
        annoCorrente = this.filtroDelegheAtt;
        this.anno.emit(annoCorrente);
        return;
      case 'storico':
        annoCorrente = this.filtroStorico;
        this.anno.emit(annoCorrente);
        return;
      case 'recuperopresenze':
        annoCorrente = this.filtroAtt;
        this.anno.emit(annoCorrente);
        return;
      case 'giustificaassenze':
        annoCorrente = this.filtroAtt;
        this.anno.emit(annoCorrente);
        return;
      case 'idoneita':
        annoCorrente = this.filtroAtt;
        this.anno.emit(annoCorrente);
        return;
      }
  }

  async calcolaFiltroAnnoSolare() {
    let id;
    if (this.userService.isPTA()) {
      id = 0;
    } else {
      try {
        id = this.userService.getDocenteCorrente().id;
      } catch(err) {
        id = 0;
      }
    }
    this.rilevazionePresenzeService
      .cercaAnnoSolareMin(id)
      .subscribe(
        (annoSolareMin) => {
          if (annoSolareMin === 0) {
            annoSolareMin = this.annoSolareCorrente;
          }
          const differenza = this.annoSolareCorrente - annoSolareMin;
          for (let i = differenza - 1; i > 0; i--) {
            this.anniSolare.push((annoSolareMin + i).toString());
          }
          if (this.annoSolareCorrente !== annoSolareMin) {
            this.anniSolare.push((annoSolareMin).toString());
          }
        }
      );
  }

  async calcolaFiltroAnnoAccademico() {
    let id;
    if (this.userService.isPTA()) {
      id = 0;
    } else {
      try {
        id = this.userService.getDocenteCorrente().id;
      } catch(err) {
        id = 0;
      }
    }
    this.rilevazionePresenzeService
      .cercaAnnoOffertaMin(id)
      .subscribe(
        (annoAccademicoMin) => {
          if (annoAccademicoMin === 0) {
            annoAccademicoMin = this.annoAccademicoCorrente;
          }
          const differenza = this.annoAccademicoCorrente - annoAccademicoMin;
          for (let i = differenza - 1; i > 0; i--) {
            this.anniOfferta.push((annoAccademicoMin + i).toString() + '/' + (annoAccademicoMin + (i + 1)).toString());
          }
          if (this.annoAccademicoCorrente !== annoAccademicoMin) {
            this.anniOfferta.push((annoAccademicoMin).toString() + '/' + (annoAccademicoMin + 1).toString());
          }
        }
      );
  }
}
